import React from 'react';
import TextAreaCtrl from '../../../../components/UI/Input/text-area-ctrl';
import CommonTitle from '../../component/common-title';

function ReservationNotes(props) {
    const { renterComments, setRenterComments, onChangesMade, disabled } = props;
    const onHandleChange = (value) => {
        setRenterComments(value);
        onChangesMade(true);
    }
    return (
        <div className="common-res-container input-ctrl">
            <CommonTitle title="Rental Special Request (Optional)" classNames="common-title" />
            {/* <textarea
                id="renterComments"
                name="renterComments"
                disabled={disabled}
                value={renterComments || ""}
                onChange={(e) => onHandleChange(e)}
                iconClass={`fa fa-comments ${disabled ? "font-color-disabled" : "font-color-1"} font-size-2`}
            /> */}
            <TextAreaCtrl
                id="renterComments"
                name="renterComments"
                value={renterComments || ""}
                onChange={onHandleChange}
                placeholder="Note(s)"
                iconClass={`fa fa-comments ${disabled ? "font-color-disabled" : "font-color-1"} font-size-2`}
                disabled={disabled}
            />
        </div>

    )
}

export default ReservationNotes